var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trial-top-head", staticStyle: { "overflow-x": "hidden" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "trial-main" },
        [
          _vm.loader
            ? _c("div", { staticClass: "loading" }, [_vm._m(1)])
            : _vm._e(),
          _vm._v(" "),
          _vm.step === 0
            ? _c("div", { staticClass: "container welcome-sec" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "trial-ti-sec" }, [
                      _c("h2", [
                        _vm._v(
                          "EXPERIENCE B1G1 FOR 17 DAYS AND INTEGRATE GLOBAL IMPACTS INTO YOUR BUSINESS."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-2" }, [
                        _vm._v(
                          "You'll gain access to the full range of B1G1 business features and discover how the seamless integration of impacts into your everyday operations transforms your company and our world."
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-3" }, [
                        _vm._v(
                          "Start your trial by creating a global impact with $1 of giving, funded by us!"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center btn-sec" }, [
                        _c(
                          "a",
                          {
                            staticClass: "b-btn red-btn",
                            attrs: {
                              "data-v-54b4acdd": "",
                              href: "javascript:void(0)"
                            },
                            on: {
                              click: function($event) {
                                return _vm.getStarted()
                              }
                            }
                          },
                          [_vm._v("GET\n              STARTED")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(3)
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step !== 0
            ? _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "trial-ti-sec" }, [
                      _c("h2", [_vm._v(_vm._s(_vm.topHeading))]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.topText))])
                    ]),
                    _vm._v(" "),
                    _vm.step !== 2
                      ? _c(
                          "div",
                          { staticClass: "trial-image-sec d-block d-sm-none" },
                          [
                            _c("img", { attrs: { src: _vm.imagePath } }),
                            _vm._v(" "),
                            _c("div", { staticClass: "trial-img-content" }, [
                              _c("h3", [_vm._v(_vm._s(_vm.textHeading))]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.textContent))])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step !== 2
                      ? _c("div", { staticClass: "trial-plan" }, [
                          _c(
                            "aside",
                            {
                              class: _vm.waterProjSelected,
                              on: {
                                click: function($event) {
                                  return _vm.selectProject("water")
                                }
                              }
                            },
                            [
                              _c("h4", [
                                _vm._v("50 DAYS OF ACCESS TO CLEAN WATER")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/goal_icons/Cropped6.png"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "aside",
                            {
                              class: _vm.treeProjSelected,
                              on: {
                                click: function($event) {
                                  return _vm.selectProject("tree")
                                }
                              }
                            },
                            [
                              _c("h4", [_vm._v("PLANT A TREE IN THE WORLD")]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/goal_icons/Cropped15.png"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "aside",
                            {
                              class: _vm.educationProjSelected,
                              on: {
                                click: function($event) {
                                  return _vm.selectProject("education")
                                }
                              }
                            },
                            [
                              _c("h4", [
                                _vm._v("5 DAYS OF ACCESS TO EDUCATION")
                              ]),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src:
                                    "/static/front/images/goal_icons/Cropped4.png"
                                }
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.errorMsg === 1
                      ? _c("div", { staticClass: "error-me" }, [
                          _vm._v(
                            "\n            Please select one of the above impacts before you proceed.\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step !== 2
                      ? _c("div", { staticClass: "text-center btn-sec" }, [
                          _c(
                            "a",
                            {
                              staticClass: "b-btn red-btn",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.submitImpact()
                                }
                              }
                            },
                            [_vm._v("SUBMIT YOUR IMPACT")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 2
                      ? _c("div", { staticClass: "trial-form" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.project.id,
                                expression: "form.project.id"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "projectId",
                              id: "projectId"
                            },
                            domProps: { value: _vm.form.project.id },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form.project,
                                  "id",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.project.impact_level_id,
                                expression: "form.project.impact_level_id"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "impactId",
                              id: "impactId"
                            },
                            domProps: {
                              value: _vm.form.project.impact_level_id
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form.project,
                                  "impact_level_id",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.project.quantity,
                                expression: "form.project.quantity"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "quantity",
                              id: "quantity"
                            },
                            domProps: { value: _vm.form.project.quantity },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form.project,
                                  "quantity",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.project.price,
                                expression: "form.project.price"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "price",
                              id: "price"
                            },
                            domProps: { value: _vm.form.project.price },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form.project,
                                  "price",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.user
                            ? _c("p", { staticClass: "warning-text" }, [
                                _vm._v(
                                  "You are currently logged in as a member and cannot submit this\n              form."
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.getUserWarningAlert()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "col two-in" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.first_name,
                                      expression: "form.first_name"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: _vm.getError("first_name")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "text",
                                    name: "first_name",
                                    id: "first_name",
                                    placeholder: "First Name",
                                    maxlength: "40",
                                    disabled: _vm.user
                                  },
                                  domProps: { value: _vm.form.first_name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "first_name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.last_name,
                                      expression: "form.last_name"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: _vm.getError("last_name")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "text",
                                    name: "last_name",
                                    id: "last_name",
                                    placeholder: "Last Name",
                                    maxlength: "40",
                                    disabled: _vm.user
                                  },
                                  domProps: { value: _vm.form.last_name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "last_name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.email,
                                      expression: "form.email"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email|uniqueEmail",
                                      expression: "'required|email|uniqueEmail'"
                                    }
                                  ],
                                  class: _vm.getError("email") ? " error" : "",
                                  attrs: {
                                    type: "email",
                                    name: "email",
                                    id: "email",
                                    placeholder: "Email",
                                    disabled: _vm.user
                                  },
                                  domProps: { value: _vm.form.email },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "email",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.errors.has("email") &&
                                          _vm.errors.first("email") !==
                                            "The email field is required",
                                        expression:
                                          "errors.has('email') && errors.first('email') !== 'The email field is required'"
                                      }
                                    ],
                                    staticClass: "help-block mt-1 p-1"
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("email")))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.company,
                                      expression: "form.company"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: _vm.getError("company")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "text",
                                    name: "company",
                                    id: "company",
                                    placeholder: "Company Name",
                                    disabled: _vm.user
                                  },
                                  domProps: { value: _vm.form.company },
                                  on: {
                                    keyup: function($event) {
                                      return _vm.checkAlphabetsOnly("company")
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "company",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("company"),
                                        expression: "errors.has('company')"
                                      }
                                    ],
                                    staticClass: "help-block mt-1 p-1"
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("company")))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _vm._v(
                                  _vm._s(_vm.country) + "\n                "
                                ),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.countryid,
                                        expression: "form.countryid"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    class: _vm.getError("countryid")
                                      ? " error"
                                      : "",
                                    attrs: {
                                      name: "countryid",
                                      id: "countryid",
                                      disabled: _vm.user
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.form,
                                          "countryid",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v("Select country")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function(country) {
                                      return _c(
                                        "option",
                                        {
                                          key: country.id,
                                          domProps: {
                                            selected:
                                              country == country.code
                                                ? "selected"
                                                : "",
                                            value: country
                                          }
                                        },
                                        [_vm._v(_vm._s(country.name))]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("countryid"),
                                        expression: "errors.has('countryid')"
                                      }
                                    ],
                                    staticClass: "help-block mt-1 p-1"
                                  },
                                  [_vm._v("The country field is required.")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col two-in" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.password,
                                      expression: "form.password"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|verify_password",
                                      expression: "'required|verify_password'"
                                    }
                                  ],
                                  ref: "password",
                                  class: _vm.getError("password")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    placeholder: "Enter Password",
                                    disabled: _vm.user
                                  },
                                  domProps: { value: _vm.form.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.form,
                                        "password",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|confirmed:password",
                                      expression:
                                        "'required|confirmed:password'"
                                    }
                                  ],
                                  class: _vm.getError("confirm_password")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "password",
                                    name: "confirm_password",
                                    id: "confirm_password",
                                    placeholder: "Re-Enter password ",
                                    disabled: _vm.user
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("password"),
                                        expression: "errors.has('password')"
                                      }
                                    ],
                                    staticClass: "help-block mt-1 p-1"
                                  },
                                  [_vm._v(_vm._s(_vm.errors.first("password")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.errors.has("confirm_password") &&
                                          _vm.errors.first(
                                            "confirm_password"
                                          ) ===
                                            "The confirm_password confirmation does not match",
                                        expression:
                                          "errors.has('confirm_password') && errors.first('confirm_password') === 'The confirm_password confirmation does not match'"
                                      }
                                    ],
                                    staticClass: "help-block mt-1 p-1"
                                  },
                                  [
                                    _vm._v(
                                      "The retype password confirmation does not match."
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col checkbox-sec" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.form.confirm,
                                      expression: "form.confirm"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  class: _vm.getError("confirm")
                                    ? " error"
                                    : "",
                                  attrs: {
                                    type: "checkbox",
                                    name: "confirm",
                                    disabled: _vm.user
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.form.confirm)
                                      ? _vm._i(_vm.form.confirm, null) > -1
                                      : _vm.form.confirm
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.form.confirm,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.form,
                                              "confirm",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              "confirm",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.form, "confirm", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(4)
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.getError("confirm")
                            ? _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  "\n                    Please read and accept our Terms and Conditions and Privacy Policy.\n                  "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col btn-sec text-center" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "b-btn white-btn",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.goToBackStep()
                                    }
                                  }
                                },
                                [_vm._v("BACK")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "b-btn red-btn",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.isFormsubmited || _vm.user
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.submitTrial()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                MAKE IT HAPPEN\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c(
                      "div",
                      { staticClass: "trial-image-sec d-none d-sm-block" },
                      [
                        _c("img", { attrs: { src: _vm.imagePath } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "trial-img-content" }, [
                          _c("h3", [_vm._v(_vm._s(_vm.textHeading))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.textContent))])
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "modal",
            {
              staticClass: "full_width_mobile",
              attrs: {
                name: "information-modal",
                id: "information-modal",
                transition: "pop-out",
                width: 880,
                adaptive: true,
                maxWidth: 880,
                height: "auto",
                scrollable: true
              }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body pop-form" }, [
                  _c("section", [
                    _c("div", { staticClass: "text-center" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/front/images/Group-118.png",
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(
                          "\n                Congratulations! You just created your B1G1 Trial account and\n                an initial impact of 50 days of access to life-saving water.\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                Small actions do make a difference. Explore some of the\n                exciting ways you can create impactful moments in your\n                business from as little as just 1 cent.\n              "
                        )
                      ]),
                      _vm._v(" "),
                      _c("h5", [_vm._v("For example, imagine if....")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "typing-main" }, [
                        _c("p", [
                          _vm._v(
                            "\n                  when you have a great meeting..."
                          ),
                          _c("span", [
                            _c("img", {
                              attrs: {
                                src: "/static/front/images/double.svg",
                                alt: ""
                              }
                            })
                          ]),
                          _vm._v(
                            "\n                  child receives access to education\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "b-btn red-btn", attrs: { href: "#" } },
                        [_vm._v("ENTER B1G1 AND GET STARTED")]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(5)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "trial-re-header" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("img", {
            staticClass: "logo-d d-none",
            attrs: { src: "/static/front/images/trial-flow-logo.png" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load" }, [
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "loadback" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center link-sec" }, [
      _c("a", { attrs: { href: "https://b1g1.com", target: "_blank" } }, [
        _vm._v("Learn more about B1G1\n               ")
      ]),
      _vm._v(" | "),
      _c(
        "a",
        {
          attrs: { href: "https://account.b1g1.com/sign-up", target: "_blank" }
        },
        [_vm._v("Register as a\n              Member ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("img", { attrs: { src: "/static/front/images/trial-new-img.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v(" I agree with "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.b1g1.com/businessforgood/terms/",
            target: "_blank"
          }
        },
        [_vm._v("the terms of\n                  B1G1")]
      ),
      _vm._v(" and\n                  "),
      _c(
        "a",
        {
          attrs: {
            href: "https://b1g1.com/businessforgood/b1g1-privacy-policy/",
            target: "_blank"
          }
        },
        [_vm._v("Privacy Policy")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", [
      _c("div", { staticClass: "footer-logo" }, [
        _c("a", { attrs: { href: "#" } }, [
          _c("img", {
            attrs: {
              src: "/static/front/images/white-footer-logo-new.png",
              alt: ""
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "footer-menu" }, [
        _c("li", [
          _c("a", { attrs: { href: "https://b1g1.com", target: "_blank" } }, [
            _vm._v("B1G1 Home")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://b1g1.com/about-us", target: "_blank" } },
            [_vm._v("About")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href:
                  "https://b1g1.com/terms-and-conditions-effective-from-1-apr-2023",
                target: "_blank"
              }
            },
            [_vm._v("Terms\n        of Use")]
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://b1g1.com/privacy-policy",
                target: "_blank"
              }
            },
            [_vm._v("Privacy Policy")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54b4acdd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54b4acdd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trial-registration/list.vue
// module id = null
// module chunks = 